import {useState, useEffect} from 'react'
import {get as getCrypto, set as setCrypto} from '../Utils/Crypto'

export default function useRecentLogin() {
    
    const [RecentLogins, setRecentLogins] = useState(getCrypto('Recent_Logins_Scan')?getCrypto('Recent_Logins_Scan'):[]);

    useEffect(() => {
        setCrypto('Recent_Logins_Scan',RecentLogins)
    }, [RecentLogins]);
	
    const get = ()=>{
        if(RecentLogins){
            return RecentLogins
        }else{
            return []
        }
    }

    const set = (user)=>{
        if(RecentLogins){
            setRecentLogins([...RecentLogins, user])
        }else{
            setRecentLogins([user])
        }
    }

    const remove = (user)=>{
        let Recents = RecentLogins.filter(item=>user!==item)
        setRecentLogins(Recents)
    }

    return {get,set,remove}
}
